// src/Config/firebase.jsx
// Escolhe produção ou sandbox conforme REACT_APP_FIREBASE_PROJECT

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getMessaging } from "firebase/messaging";
import { getFunctions } from "firebase/functions";

const firebaseConfigProd = {
  apiKey: "AIzaSyDUUkVBuzseLAHiWSLng8sC1X_tfFkyT_Y",
  authDomain: "core.fiddux.com",
  projectId: "fidduxai-rowy",
  storageBucket: "fidduxai-rowy.appspot.com",
  messagingSenderId: "647201360560",
  appId: "1:647201360560:web:b19ee50960f37504744975",
  measurementId: "G-SL0GNR4M36"
};

const firebaseConfigSandbox = {
  apiKey: "AIzaSyCPYJeijPTOdrYxb5y0-3ZUTuNB-AfoeDs",
  authDomain: "fiddux-sandbox-dev.firebaseapp.com",
  projectId: "fiddux-sandbox-dev",
  storageBucket: "fiddux-sandbox-dev.firebasestorage.app",
  messagingSenderId: "100247753098",
  appId: "1:100247753098:web:ffdebe4fd8665f95adf873"
};

const isSandbox = process.env.REACT_APP_FIREBASE_PROJECT === "fiddux-sandbox-dev";
const firebaseConfig = isSandbox ? firebaseConfigSandbox : firebaseConfigProd;

const app = initializeApp(firebaseConfig);

// --- REMOVED FOR NORMAL OPERATION ---
// setLogLevel('debug'); // Debug logging removed
// --- END REMOVAL ---

// Export Firebase service instances
export const AUTH_LOGIN = getAuth(app);
export const DATABASE = getFirestore(app);
export const STORAGE = getStorage(app);

// Messaging only works on HTTPS or localhost - make it optional for development
let MESSAGING_INSTANCE = null;
try {
  // Check if we're on a supported environment (localhost or HTTPS)
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const isHttps = window.location.protocol === 'https:';
  
  if (isLocalhost || isHttps) {
    MESSAGING_INSTANCE = getMessaging(app);
  } else {
    console.warn('Firebase Messaging: Not available on HTTP with external IP. Use localhost or HTTPS.');
  }
} catch (error) {
  console.warn('Firebase Messaging: Not available in this environment:', error.message);
}

export const MESSAGING = MESSAGING_INSTANCE;
export const FUNCTIONS = getFunctions(app);